export default __webpack_public_path__ + "static/Scroll-Image---Concrete-Sidewalk-Removal-8088153a59e7f879f4c12d8269b25ec6.jpg";